import { TransformerFunction } from './transformer-function';

export const numericOnly: TransformerFunction<string> = (value: string) => {
  return value.replace(/\D/g, '');
};
